import React, { useContext, useEffect, useRef, useState } from 'react'
import UploadModal from '../../Modals/UploadModal';
import { Context } from '../../Context/Context';
import { DEFAULTAVATAR, generateSignedurlApi, updateUserApi } from '../../Constants';
import { MdFileUpload, MdOutlineFileUpload } from 'react-icons/md';
import FieldError from '../Element/FieldError';

function ProfilePicture({setProfilePic, errorMsg, setErrorMsg}) 
{
  const {userDetails, makeApiCallFunc} = useContext(Context);
  const defaultImg = DEFAULTAVATAR;
  const [fileName, setFileName] = useState(new Date().toISOString().replace(/:/g, '-') + userDetails._id);
  const [fileToUpload, setFileToUpload] = useState(null);
  const {profilePic} = userDetails;


  // to open and close upload image
  const [uploadNew, setUploadNew] = useState(false);
  
  //image to pass to the backend 
  const [imgUrl, setImgUrl] = useState("");
  
  //image to be updated on the profile page avatar 
  const [uploadedImg, setUploadedImg] = useState((!profilePic || profilePic === "" )? defaultImg : userDetails?.profilePic)
  
  const onCrop = (preview) => {
    
    setImgUrl(preview)
  }

  const onClose = () => {
    setUploadNew(false);
    setImgUrl("");
  }
  const onSubmit = async (e,removeImage) => {
    setUploadNew(false);
    if(imgUrl || removeImage)
    {
      if(removeImage)
      {
        setProfilePic(removeImage);
        setImgUrl("")
        setUploadedImg(removeImage);    
      }
        else
        {
          setProfilePic(imgUrl);
        setImgUrl("")
        setUploadedImg(imgUrl);    

        }
 
                
    }
 
  }
 
  
  return ( 
  <div>
  <div className='flex flex-col mb-4   w-full items-center justify-center'>
    {uploadNew && <UploadModal
    uploadNew={uploadNew}
    onCrop = {onCrop}
    onSubmit = {onSubmit}
    onClose = {onClose}
    />
    }
    <div className={'flex items-center justify-center  flex-col  ' }
    onClick={()=>{setUploadNew(true);setErrorMsg((prev) => { return {...prev, "profilepic" : "" }})}}
    >
      <div className={'flex w-36 h-36  border  rounded-full ring-offset-2 cursor-pointer ' + (errorMsg.profilepic ? " border-red-500" : " border-gray-500 ")}>
        
        <img src={uploadedImg !== "" ? uploadedImg : defaultImg} alt="Preview" />
      </div>
      <div className='flex justify-between mb-2 font-medium'>
        <div 
          className=" text-xs lg:text-sm h-10 text-sky-600  bg-white rounded mt-4 flex justify-center items-center cursor-pointer px-4  border border-sky-500 px-5 hover:border-sky-600"
          >
            <MdOutlineFileUpload className='w-4 h-6 mr-1' />

            Upload your picture</div>
        {/* <div 
          className=" shadow-xl text-sm h-10 bg-gray-400 px-5 hover:bg-gray-600 text-white rounded mt-5 flex justify-center items-center cursor-pointer"
          onClick={(e)=>{onSubmit(e,true);}}>Remove</div> */}
      </div>
      
    </div>
    {errorMsg.profilepic && <FieldError>{errorMsg.profilepic}</FieldError>}
    </div>
    
    </div>
  )
}

export default ProfilePicture